module.exports = __webpack_public_path__ + "static/media/shop-front-spraying.b812344e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/optimised/shop-front-spraying.jpg
// module id = 86
// module chunks = 0